import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Row, Col, Select } from 'antd';
import useApi from '../../hooks/useApi';

const ModalAdd = ({ visible, onCancel, onConfirm }) => {
  const [form] = Form.useForm();
  const [categorias, setCategorias] = useState([]);

  const { callApi: addDepartamento } = useApi('https://vision.alfama.com/api/add/departamentos', {
    method: 'POST',
    includeToken: true,
    successMessage: 'Departamento adicionado com sucesso!',
    errorMessage: 'Erro ao adicionar Departamento'
  });

  const { callApi: viewCategorias } = useApi('https://vision.alfama.com/api/view/categorias', { 
    includeToken: true,
  });

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const response = await viewCategorias();
        if (response && Array.isArray(response)) {
          const formattedCategorias = response.map(categoria => ({
            value: categoria.id,
            label: categoria.nome
          }));
          setCategorias(formattedCategorias);
        }
      } catch (error) {
        console.error('Erro ao buscar categorias:', error);
      }
    };

    fetchCategorias();
  }, []);

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      await addDepartamento(values);
      form.resetFields();
      onConfirm(true);
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      console.error('Erro ao adicionar departamento:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Adicionar Departamento"
      open={visible}
      onCancel={handleCancel}
      onOk={handleConfirm}
      okText="Adicionar"
      cancelText="Cancelar"
      maskClosable={false}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="nome"
              label="Nome"
              rules={[{ required: true, message: 'Por favor, insira o nome do departamento' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="categoria"
              label="Categoria"
              rules={[{ required: true, message: 'Por favor, selecione uma categoria' }]}
            >
              <Select
                placeholder="Selecione uma categoria"
                options={categorias}
                loading={categorias.length === 0}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalAdd;